import { formatDate, registerLocaleData } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { alert, confirm } from 'devextreme/ui/dialog';
import * as moment from 'moment';
import { NgxSpinnerService } from "ngx-spinner";
import { Apiservice } from '../../services/api.service';
import { Utenteservice } from '../../services/utente.service';


import { ActivatedRoute, Router } from '@angular/router';
import ArrayStore from 'devextreme/data/array_store';

import { environment } from '../../../environments/environment';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';

//import $ from 'jquery'; 
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  //linkDiretta='https://vimeo.com/event/1698194/embed?autoplay=1&loop=0&muted=1'

  loginShow: boolean = true;
  attemptingLogin = true;
  loggatoinattesadilicenza = false;
  SimulaCreazionePiattaforma = true;
  userButton
  tipoutente = [{ id: 1, descrizione: 'owner' }, { id: 2, descrizione: "super administrator" }, { id: 3, descrizione: "administrator" }, { id: 4, descrizione: "ADVANCED USER" }, { id: 5, descrizione: "STANDARD USER" }, { id: 6, descrizione: "RENTRI" }, { id: 7, descrizione: "API" }, { id: 8, descrizione: "APP" }, { id: 9, descrizione: "API ESTERNO" }, { id: 10, descrizione: "AGENTE" }, { id: 11, descrizione: "UTENTE SEGRETERIA" }]
  passwordButtonOwnerN: {
    // icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVRYw+2YP0tcQRTFz65xFVJZpBBS2O2qVSrRUkwqYfUDpBbWQu3ELt/HLRQ/Q8RCGxVJrRDEwj9sTATxZ/Hugo4zL/NmV1xhD9xi59177pl9986fVwLUSyi/tYC+oL6gbuNDYtyUpLqkaUmfJY3a+G9JZ5J2JW1J2ivMDBSxeWCfeBxYTHSOWMcRYLOAEBebxtEVQWPASQdi2jgxro4E1YDTQIJjYM18hszGbew4EHNq/kmCvgDnHtI7YBko58SWgSXg1hN/btyFBM0AlwExczG1YDZrMS4uLUeUoDmgFfjLGwXEtG05wNXyTc4NXgzMCOAIGHD8q0ATuDZrempkwGJ9+AfUQ4K+A/eEseqZ/UbgdUw4fqs5vPeW+5mgBvBAPkLd8cPju+341P7D/WAaJGCdOFQI14kr6o/zvBKZYz11L5Okv5KGA89Kzu9K0b0s5ZXt5PjuOL6TRV5ZalFP4F+rrnhZ1Cs5vN6ijmn7Q162/ThZq9+YNW3MbfvDAOed5cxdGL+RFaUPKQtjI8DVAr66/u9i6+jJzTXm+HFEVqxVYBD4SNZNKzk109HxoycPaG0bIeugVDTp4hH2qdXJDu6xOAAWiuQoQdLHhvY1aEZSVdInG7+Q9EvSz9RrUKqgV0PP3Vz7gvqCOsUj+CxC9LB1Dc8AAAASdEVYdEVYSUY6T3JpZW50YXRpb24AMYRY7O8AAAAASUVORK5CYII=",
    icon: string; type: string; class: string; disabled: boolean; onClick: () => void;
  };
  Comod: {
    icon: string; //"fa fa-lock",
    type: string; class: string; disabled: boolean; onClick: () => void;
  };
  Ruolo: string;
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.attemptingLogin) {
      if (event.key == 'Escape') {
        $("#sect1").removeClass("do-more-things");
        // era attivo this.attemptingLogin = false;
      }
    } else
      if (event.key == 'Enter') {
        this.premutoclick();
        //
      }
  }

  is_pin; // l'utente richiede pin
  is_pin_notifica; //come

  fotoprofilo = "";
  pippo;
  tipoUserLicenzaSelect;
  username = "";
  password = "";
  pinInserito = "";
  pp;
  Ricordami = false;
  public now: Date = new Date();
  nowT: number;
  nomeCompleto = "";
  todaysDataTime = '';
  imagSource = ''
  startImgIndex = 1;
  effects = true;
  UtenteOwner = false;
  step = 0;
  error = 0;
  err1 = false;
  err1C = false;
  err2 = false;
  nomeutente?: string;
  UtentiCheHannoAvutoAccesso = [];
  UltimoAccesso;
  ErrMessage = "Accedi";
  BtnText = "Accedi";
  Newusername = "";
  passOwner = "";
  oldpass = "";
  newpass = "";
  confirmPassword = "";
  confirmPasswordOwner = ""
  tipnotifica;
  tiponotifica;
  UtenteSmallLogin = "";
  LicenzaSelezionata = "";
  LicenzaSelezionataDB = 0;
  fastLoginLicenza = "";
  myThis;
  tme: any;
  temUserInfo: any;
  priorities = [
    "email",
    "sms"
  ];
  licenze: Licenze[];
  licenzeDB: LicenzeDB[];
  data: any;
  dataDB: any;
  //****************
  passwordMode: string;
  passwordModeOwner: string;
  passwordButton: any;
  passwordButtonOwner: any;


  LINK_PRIVACY_POLICY: string = environment.LINK_PRIVACY_POLICY
  LINK_COOCKIE_POLICY: string = environment.LINK_COOCKIE_POLICY
  LINK_ACCESSIBILITA_POLICY: string = environment.LINK_ACCESSIBILITA_POLICY
  constructor(private spinner: NgxSpinnerService,
    private route: Router,
    private appService: Apiservice,
    public utenteService: Utenteservice,
    private activatedroute: ActivatedRoute,
    private dati: FormsTemplateService,
    private userComponentService: ComponentService,
    private cdRef: ChangeDetectorRef
  ) {
    let myThis = this;
    this.fotoprofilo = environment.BASE_PUBLIC_IMAGE;
    this.tme = "?_" + moment.now();

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        //do whatever you want
        myThis.effects = false;
        console.log("Hidden");
      }

      else {
        //do whatever you want
        myThis.effects = true;
        console.log("SHOWN");
      }
    });


    this.passwordMode = 'password';
    this.passwordModeOwner = 'password';

    this.userButton = {
      icon: "assets/icons/USERNAME.svg",//"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVRYw+2YP0tcQRTFz65xFVJZpBBS2O2qVSrRUkwqYfUDpBbWQu3ELt/HLRQ/Q8RCGxVJrRDEwj9sTATxZ/Hugo4zL/NmV1xhD9xi59177pl9986fVwLUSyi/tYC+oL6gbuNDYtyUpLqkaUmfJY3a+G9JZ5J2JW1J2ivMDBSxeWCfeBxYTHSOWMcRYLOAEBebxtEVQWPASQdi2jgxro4E1YDTQIJjYM18hszGbew4EHNq/kmCvgDnHtI7YBko58SWgSXg1hN/btyFBM0AlwExczG1YDZrMS4uLUeUoDmgFfjLGwXEtG05wNXyTc4NXgzMCOAIGHD8q0ATuDZrempkwGJ9+AfUQ4K+A/eEseqZ/UbgdUw4fqs5vPeW+5mgBvBAPkLd8cPju+341P7D/WAaJGCdOFQI14kr6o/zvBKZYz11L5Okv5KGA89Kzu9K0b0s5ZXt5PjuOL6TRV5ZalFP4F+rrnhZ1Cs5vN6ijmn7Q162/ThZq9+YNW3MbfvDAOed5cxdGL+RFaUPKQtjI8DVAr66/u9i6+jJzTXm+HFEVqxVYBD4SNZNKzk109HxoycPaG0bIeugVDTp4hH2qdXJDu6xOAAWiuQoQdLHhvY1aEZSVdInG7+Q9EvSz9RrUKqgV0PP3Vz7gvqCOsUj+CxC9LB1Dc8AAAASdEVYdEVYSUY6T3JpZW50YXRpb24AMYRY7O8AAAAASUVORK5CYII=",
      type: "default",
      onClick: () => {
        //this.passwordMode = this.passwordMode === "text" ? "password" : "text";
      }
    };

    this.passwordButton = {
      icon: "assets/icons/MOSTRA_PASSWORD.svg",//"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVRYw+2YP0tcQRTFz65xFVJZpBBS2O2qVSrRUkwqYfUDpBbWQu3ELt/HLRQ/Q8RCGxVJrRDEwj9sTATxZ/Hugo4zL/NmV1xhD9xi59177pl9986fVwLUSyi/tYC+oL6gbuNDYtyUpLqkaUmfJY3a+G9JZ5J2JW1J2ivMDBSxeWCfeBxYTHSOWMcRYLOAEBebxtEVQWPASQdi2jgxro4E1YDTQIJjYM18hszGbew4EHNq/kmCvgDnHtI7YBko58SWgSXg1hN/btyFBM0AlwExczG1YDZrMS4uLUeUoDmgFfjLGwXEtG05wNXyTc4NXgzMCOAIGHD8q0ATuDZrempkwGJ9+AfUQ4K+A/eEseqZ/UbgdUw4fqs5vPeW+5mgBvBAPkLd8cPju+341P7D/WAaJGCdOFQI14kr6o/zvBKZYz11L5Okv5KGA89Kzu9K0b0s5ZXt5PjuOL6TRV5ZalFP4F+rrnhZ1Cs5vN6ijmn7Q162/ThZq9+YNW3MbfvDAOed5cxdGL+RFaUPKQtjI8DVAr66/u9i6+jJzTXm+HFEVqxVYBD4SNZNKzk109HxoycPaG0bIeugVDTp4hH2qdXJDu6xOAAWiuQoQdLHhvY1aEZSVdInG7+Q9EvSz9RrUKqgV0PP3Vz7gvqCOsUj+CxC9LB1Dc8AAAASdEVYdEVYSUY6T3JpZW50YXRpb24AMYRY7O8AAAAASUVORK5CYII=",
      type: "default",
      onClick: () => {
        this.passwordMode = this.passwordMode === "text" ? "password" : "text";
      }
    };
    this.passwordButtonOwner = {
      // icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVRYw+2YP0tcQRTFz65xFVJZpBBS2O2qVSrRUkwqYfUDpBbWQu3ELt/HLRQ/Q8RCGxVJrRDEwj9sTATxZ/Hugo4zL/NmV1xhD9xi59177pl9986fVwLUSyi/tYC+oL6gbuNDYtyUpLqkaUmfJY3a+G9JZ5J2JW1J2ivMDBSxeWCfeBxYTHSOWMcRYLOAEBebxtEVQWPASQdi2jgxro4E1YDTQIJjYM18hszGbew4EHNq/kmCvgDnHtI7YBko58SWgSXg1hN/btyFBM0AlwExczG1YDZrMS4uLUeUoDmgFfjLGwXEtG05wNXyTc4NXgzMCOAIGHD8q0ATuDZrempkwGJ9+AfUQ4K+A/eEseqZ/UbgdUw4fqs5vPeW+5mgBvBAPkLd8cPju+341P7D/WAaJGCdOFQI14kr6o/zvBKZYz11L5Okv5KGA89Kzu9K0b0s5ZXt5PjuOL6TRV5ZalFP4F+rrnhZ1Cs5vN6ijmn7Q162/ThZq9+YNW3MbfvDAOed5cxdGL+RFaUPKQtjI8DVAr66/u9i6+jJzTXm+HFEVqxVYBD4SNZNKzk109HxoycPaG0bIeugVDTp4hH2qdXJDu6xOAAWiuQoQdLHhvY1aEZSVdInG7+Q9EvSz9RrUKqgV0PP3Vz7gvqCOsUj+CxC9LB1Dc8AAAASdEVYdEVYSUY6T3JpZW50YXRpb24AMYRY7O8AAAAASUVORK5CYII=",
      icon: "assets/icons/MOSTRA_PASSWORD.svg",//"fa fa-user",
      type: "default",
      class: 'class-name',
      disabled: false,

      onClick: () => {

        this.passwordModeOwner = this.passwordModeOwner === "text" ? "password" : "text";
      }
    };

    this.passwordButtonOwnerN = {
      icon: "assets/icons/PASSWORD.svg",//"fa fa-lock",
      type: "default",
      class: 'class-name',
      disabled: false,
      onClick: () => {
        //this.passwordModeOwner = this.passwordModeOwner === "text" ? "password" : "text";
      }
    };
    this.Comod = {
      icon: "assets/icons/comodblu.png",//"fa fa-lock",
      type: "default",
      class: 'class-name',
      disabled: false,
      onClick: () => {
        //this.passwordModeOwner = this.passwordModeOwner === "text" ? "password" : "text";
      }
    };

    /*this.dataDB = new ArrayStore({
      data: this.licenzeDB,
      key: "id"
    });*/


    this.data = new ArrayStore({
      data: this.licenze,
      key: "id"
    });

    let usrC = localStorage.getItem('artemide_credenziali');
    console.log("Get item artemide_credenziali ", usrC)
    if (usrC) this.UtentiCheHannoAvutoAccesso = JSON.parse(localStorage.getItem('artemide_credenziali'));
    console.log("Eccochi si � collegato", this.UtentiCheHannoAvutoAccesso);
    let ultimoUtente = '';
    let ultimoAccessoS = localStorage.getItem('userrentrincloud');
    if (ultimoAccessoS) this.UltimoAccesso = JSON.parse(localStorage.getItem('userrentrincloud'));
    this.utenteService.setValueAnnoRiferimento(this.UtentiCheHannoAvutoAccesso['annoSelected'])
    setInterval(() => {

      this.nowT = Date.now();
      this.now = new Date();
      if (1 == 1) { //!this.attemptingLogin
        this.startImgIndex++;
        if (this.startImgIndex > 3) this.startImgIndex = 1;

        let pp = "url('../../../assets/images/carosello_login/sfondo" + this.startImgIndex + ".jpg')";
        this.pp = pp;
        if (this.effects) {
          $('#sect1')
            .animate({ opacity: 0.5 }, "2000  ", function () {
              $(this).animate({ opacity: 1 }, 1000)
                .css({ 'background-image': pp })
              //.animate({opacity: 1});
            });
        }

        // this.imagSource="../../../assets/images/sfondo"+this.startImgIndex+".jpg";
      }
      this.todaysDataTime = formatDate(this.now, 'dd-MM-yyyy hh:mm:ss ', 'it-IT');

    }, 15000);
  }

  loginsmall(event) {
    //alert(event);
    this.username = this.UtentiCheHannoAvutoAccesso[event].userName;
    this.fastLoginLicenza = this.UtentiCheHannoAvutoAccesso[event].licenza;
    this.step = 0;
    this.premutoclick();
    this.step = 0;
    this.UtenteSmallLogin = `url("assets/images/img_avatar2.png?_${Date.now()})`;
    this.cdRef.detectChanges()
    //this.Accedi();
    //UtentiCheHannoAvutoAccesso[event];

  }
  premutoclick() {
    $('#sect1').stop();
    return;
    if (this.step == 3) this.step = 0;
    if (this.attemptingLogin) {

      $("#sect1").removeClass("do-more-things");
      this.attemptingLogin = false;
      this.password = '';
      return;
    }
    //this.Accedi();
    // if(this.attemptingLogin) return;

    //do-more-things

    $("#sect1").addClass("do-more-things");

    $('#sect1q')
      .animate({ opacity: 0.1 }, "1000  ", function () {
        // $(this).animate({opacity:1},1000)
        //   .css({'background-image': this.pp  })
        //.animate({opacity: 1});
      });

    this.attemptingLogin = !this.attemptingLogin;//true;
    //alert("click");

  }

  RichiediNuovoPin(idx) {
    //alert(tipoNotifica);
    //richiestapin
    //	tiponotificapin 0=email 1=sms
    this.spinner.show();
    //alert(tipoNotifica);
    // invia pin per email
    this.appService.GeneraInviaPin(idx).then(response => {
      this.spinner.hide();
      if (response['codeMessage'] < 0) {
        this.BtnText = "ok";
        this.ErrMessage = response['descrMessage'];//"Non Possibile generare il PIN di Accesso";
        this.error = 1;
      } else {
        this.step = 2;
        this.BtnText = "ok";
        this.ErrMessage = "E' stato inviato PIN per accedere alla piattaforma"
        this.error = 1;
      }
    })
      .catch((err: HttpErrorResponse) => {
        //this.showMessageError(err);
        alert("errore Invia PIN", "Accesso");
        this.spinner.hide();
        console.log(err);
      });

  }
  AnnullaOperazione() {
    this.BtnText = "Accedi";

    this.nomeutente = undefined;

    this.UtenteSmallLogin = `url("assets/images/img_avatar2.png?_${Date.now()})`;

    $("#form-avatar").css("background-image", this.UtenteSmallLogin);

    this.step = 0;
  }
  RecuperaPassword() {
    this.BtnText = "Conferma";
    //this.ErrMessage="E' stato inviata un email all'indirizzo per il reset della password";
    //this.error=1;
    //this.step=1;

    this.appService.RecuperaPassword(this.Newusername).then(response => {
      if (response['codeMessage'] < 0) {
        this.Newusername = '';
        // this.BtnText="ok";
        this.ErrMessage = response['message'];
        this.error = 1;
      } else {
        this.ErrMessage = "Ti è stata inviata un' email all'indirizzo per il reset della password";
        this.error = 1;
        this.password = "";
        this.step = 0;
        this.error == 0
        return;
      }

    })
      .catch((err: HttpErrorResponse) => {
        //this.showMessageError(err);
        console.log(err);
      });
  }


  DammiAziendeDiLavoro(licenza: string) {
    this.Ruolo = '';
    // tipoutente
    //ddd
    return this.appService.SetLicenzaLavoro(licenza).then(response => {
      console.log("Ecco i DB A cui è associato " + response['aziende']);
      this.Ruolo = this.tipoutente[response['tipoUtente'] - 1]['descrizione'];
      this.Ruolo = this.Ruolo.toLowerCase();
      if (response['tipoUtente'] > 2) {
        this.licenzeDB = response['aziende'];
        this.dataDB = new ArrayStore({
          data: this.licenzeDB,
          key: "id"
        });
        if (this.licenzeDB.length > 0)
          this.LicenzaSelezionataDB = this.licenzeDB[0]['id'];
      } else {
        this.dataDB = null;
      }
      this.cdRef.detectChanges()
    }).catch(x => {
      console.error(x)
    })
  }

  ControllaAccesso(response: any) {
    // In Ok login ma in attesa di setta licenza 

    this.loggatoinattesadilicenza = true;
    this.attemptingLogin = true;
    this.utenteService.SetToken(response['token']);
    this.licenze = response['licenze'];

    this.data = new ArrayStore({
      data: this.licenze,
      key: "id"
    });
    this.LicenzaSelezionata = "";
    this.LicenzaSelezionataDB = 0;
    this.UtenteOwner = false;
    this.UtenteOwner = response['isOwner'];

    if (!this.UtenteOwner) {
      if (this.licenze.length == 0) {
        alert("Utente non associato a nessuna Licenza", "Accesso");
        this.step = 0;
        return;
      }
    }
    if (this.licenze.length > 0) {
      this.LicenzaSelezionata = this.licenze[0]['id'];
      this.tipoUserLicenzaSelect = this.licenze[0]['tipoUtente'];
      // if(this.tipoUserLicenzaSelect>2) 
      /*this.DammiAziendeDiLavoro(this.LicenzaSelezionata).then(response=>{
      });*/

    }
    if (this.UtenteOwner) this.LicenzaSelezionata = "00000"; else {
      if (this.licenze.length == 1) this.LicenzaSelezionata = this.licenze[0]['id']
    }
    this.nomeutente = response['nomeCompleto'];
    this.UtenteSmallLogin = "url('" + environment.BASE_PUBLIC_IMAGE + response['foto'] + this.tme + "')";
    // this.fotoprofilo=environment.BASE_PUBLIC_IMAGE;
    if (response['foto']) $("#form-avatar").css("background-image", this.UtenteSmallLogin);
    this.Newusername = this.username;
    localStorage.setItem('EXAGERATOWEB', JSON.stringify(this.utenteService.AccessiExagerato.user));
    localStorage.setItem('EXAGERATOWEB', JSON.stringify(this.utenteService.AccessiExagerato.user));
    this.BtnText = "Imposta Licenza";
    localStorage.setItem('userrentrincloud', JSON.stringify(response));
    this.utenteService.SetetUserInfo(response);
    if (this.UtenteOwner) {
      this.route.navigate(['/owner'], { skipLocationChange: false });
      setTimeout(() => {
        this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso);
      }, 200);
      return;
    }

    if (this.tipoUserLicenzaSelect == 2) { //SuperAdmin                  
      if (this.licenze.length == 1) {
        this.step = 20;
        this.Accedi();
        return;
      } else {
        this.step = 20;
        return;
      }
    }
    if (this.tipoUserLicenzaSelect > 2) { //Da admin in poi                 
      this.DammiAziendeDiLavoro(this.LicenzaSelezionata).then(esponser => {
        if (this.licenze.length == 1 && this.licenzeDB && this.licenzeDB.length == 1) {
          this.step = 20;
          this.Accedi();
          return;
        } else {
          this.step = 20;
          return;
        }
      }).catch(x => {
        console.error(x)
      });
    }
    this.cdRef.detectChanges()
    return;



    //------------- end controlla accesso
  }
  CambioLicenza() {
    alert("this.LicenzaSelezionata", "www");
  }
  Accedi(flag?: any) {

    if (this.err1C == true) {
      this.error = 0;
      this.BtnText = "Crea Owner"
      return;
    }
    if (this.step == -1) {


      if (this.confirmPasswordOwner != this.passOwner) {

        alert('La password confermata non coincide con la password scelta', 'Attenzione!')
        return
      }

      let userOwner = {
        "userName": this.username,
        "nomeCompleto": this.nomeCompleto,
        "owner": true,
        "sospeso": false,
        "tipoUtente": 1,
        "accessoConPIN": 0,
        "password": this.passOwner
      }

      this.appService.CreaOwner(userOwner).then(response => {
        if (response['codeMessage'] < 0) {
          // this.username="";
          // this.nomeCompleto="";
          // this.passOwner="";
          this.BtnText = "Crea Owner";
          this.ErrMessage = response['descrMessage'];//"Non Possibile generare il PIN di Accesso";
          this.err1C = true;
        } else {
          this.step = 0;
          this.BtnText = "ok";
          //this.ErrMessage="E' stato inviato PIN per accedere alla piattaforma"
          //this.error=1;
        }

      }).catch((err: HttpErrorResponse) => {
        // this.username="";
        // this.nomeCompleto="";
        // this.passOwner="";
        this.appService.parseHttpErrorResponse(err);
      }); // info

      return;
    }



    if (this.error == 1) {
      this.error = 0;
      this.BtnText = "Accedi"
      this.UtenteSmallLogin = `url("assets/images/img_avatar2.png?_${Date.now()}")`;
      return;
    }

    if (this.step == 3) {
      this.RecuperaPassword();
      return;
    }

    //qui
    if (this.step == 9) {  //force password

      if (this.confirmPassword != this.newpass) {

        alert('La password confermata non coincide con la nuova password scelta', 'Attenzione!')
        return
      }


      this.appService.ForcePassword(this.username, this.oldpass, this.newpass).then(response => {
        if (response['codeMessage'] < 0) {
          this.oldpass = '';
          this.newpass = '';
          this.BtnText = "ok";
          //this.err1=true
          this.ErrMessage = response['descrMessage'];
          this.error = 1;
        } else {
          this.step = 0;
          alert("Cambio password avvenuto con successo.<br> Rifai login con la password appena inserita", "Cambio Password");
          this.utenteService.LogOut();
          //this.ErrMessage='Cambio password avvenuto con successo';
          this.error = 0;
          return;
        }

      })
        .catch((err: HttpErrorResponse) => {
          this.appService.parseHttpErrorResponse(err);
        });
    }

    if (this.step == 20) {
      ///Token/SetLicenzaLavoro  
      this.appService.SetLicenzaLavoro(this.LicenzaSelezionata).then(response => {
        console.log("ecco in SetLicenza di lavoro ", response);
        if (response['tipoUtente'] == 7) {
          this.utenteService.LogOut()
          alert('UserName o Password Errati', 'Accesso')
          this.route.navigateByUrl('login', { skipLocationChange: true })
          this.step = 0
          this.LicenzaSelezionata = ''
          this.BtnText = 'Accedi'
          this.nomeutente = undefined
          return
        }
        //this.utenteService.SetetUserInfo(response);
        this.utenteService.AccessiExagerato.licenzaKey = this.LicenzaSelezionata;
        this.utenteService.AccessiExagerato.connesso = true;
        this.attemptingLogin = true;
        //SetDBLavoro
        // era attivo this.effects = false;
        /*
        if(response['tipoUtente']>2){
          this.licenzeDB=response['aziende'];
          this.dataDB = new ArrayStore({
            data: this.licenzeDB,
            key: "id"
          });
          this.step=21;
          return;
        }    */

        if (response['tipoUtente'] > 2) {
          //alert(response['tipoUtente'],"Tipo Utente")   ;   
          this.appService.SetDBLavoro(this.LicenzaSelezionataDB).then(response => {
            this.appService.GetUserInfo().then(response => {

              this.utenteService.SetetUserInfo(response);
              this.utenteService.AccessiExagerato.connesso = true;
              this.utenteService.AccessiExagerato.loggato = true;
              this.attemptingLogin = true;
              this.effects = false;
              this.userComponentService.destroyComponentNavigation();

              if (response['tipoUtente'] == 6) { // utente web
                this.route.navigate(['/showRentri']).then(e => console.log(e)).catch(e => console.log(e));
              }
              else
                this.route.navigate(['/main'], { skipLocationChange: false });
            }).catch((err: HttpErrorResponse) => {
              console.error(err)
              this.appService.parseHttpErrorResponse(err);
            }); // info
          }).catch((err: HttpErrorResponse) => {
            console.error(err)
            this.appService.parseHttpErrorResponse(err);
          }); // info     dashboard            
        }
        else {
          this.appService.GetUserInfo().then(response => {
            console.log(response)
            this.utenteService.SetetUserInfo(response);
            this.utenteService.AccessiExagerato.connesso = true;
            this.utenteService.AccessiExagerato.loggato = true;
            this.attemptingLogin = true;
            this.effects = false;
            //this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso); 
            this.route.navigate(['/owner']).then(e => console.log(e)).catch(e => console.log(e));
          }).catch((err: HttpErrorResponse) => {
            this.appService.parseHttpErrorResponse(err);
          }); // info

          return;
        }


      }).catch((err: HttpErrorResponse) => {
        this.spinner.hide();
        this.appService.parseHttpErrorResponse(err);
      });
    }




    if (this.step == 2) {
      this.spinner.show();
      //      this.appService.checkPin(this.username,this.password,this.pinInserito).then(response=>{
      this.appService.checkPin(this.pinInserito).then(response => {
        this.spinner.hide();
        if (response['codeMessage'] < 0) {
          this.pinInserito = '';
          this.BtnText = "ok";
          //this.err1=true
          this.ErrMessage = response['descrMessage'];
          this.error = 1;
        } else {
          //--------------------Zorro--------------------------------------
          //----------------------------------------------------------
          this.ControllaAccesso(this.temUserInfo);
          return;
          this.step = 20;
          this.Accedi();
          return;
          this.loggatoinattesadilicenza = true;
          this.attemptingLogin = true;
          this.utenteService.SetToken(this.temUserInfo['token']);
          this.licenze = this.temUserInfo['licenze'];
          this.data = new ArrayStore({
            data: this.licenze,
            key: "id"
          });
          this.LicenzaSelezionata = "";
          this.LicenzaSelezionataDB = 0;
          this.UtenteOwner = false;
          this.UtenteOwner = this.temUserInfo['isOwner'];

          if (this.licenze.length > 0 && this.tipoUserLicenzaSelect > 2) {
            this.LicenzaSelezionata = this.licenze[0]['id'];
            this.DammiAziendeDiLavoro(this.LicenzaSelezionata).then(response => {
              this.nomeutente = this.temUserInfo['nomeCompleto'];
              this.UtenteSmallLogin = "url('" + environment.BASE_PUBLIC_IMAGE + this.temUserInfo['foto'] + this.tme + "')";
              if (this.temUserInfo['foto']) $("#form-avatar").css("background-image", this.UtenteSmallLogin);
              this.Newusername = this.username;


              this.step = 20;
              return;
            });
          }
          if (this.UtenteOwner) this.LicenzaSelezionata = "00000"; else {
            if (this.licenze.length == 1) this.LicenzaSelezionata = this.licenze[0]['id']
          }
          this.nomeutente = this.temUserInfo['nomeCompleto'];
          this.UtenteSmallLogin = "url('" + environment.BASE_PUBLIC_IMAGE + this.temUserInfo['foto'] + this.tme + "')";
          if (this.temUserInfo['foto']) $("#form-avatar").css("background-image", this.UtenteSmallLogin);
          this.Newusername = this.username;


          this.step = 20;
          return;



          this.appService.GetUserInfo().then(response => {
            this.utenteService.SetetUserInfo(response);
          }).catch((err: HttpErrorResponse) => {
            this.appService.parseHttpErrorResponse(err);
          }); // info
          this.utenteService.AccessiExagerato.connesso = true;
          this.utenteService.AccessiExagerato.loggato = true;
          this.attemptingLogin = true;
          this.effects = false;
          //this.route.navigateByUrl("/dashboard",{skipLocationChange: true});

          this.route.navigate(['/dashboard'], { skipLocationChange: true });
          return;
        }

      })
        .catch((err: HttpErrorResponse) => {
          this.spinner.hide();
          this.appService.parseHttpErrorResponse(err);
        });
    }


    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx this.LicenzaSelezionata xxxxxxxxxxxxxxxxxxxxxxxxx
    if (this.step == 0) {
      this.spinner.show();
      this.appService.errore500 = false;
      this.appService.Login(this.username, this.password, this.LicenzaSelezionata, flag).then(response => {
        console.log("login", response);
        this.spinner.hide();

        if (response['codeMessage'] == -1) {
          this.password = '';
          this.BtnText = "Accedi";
          this.ErrMessage = response['descrMessage'];
          this.err2 = true;
          alert(this.ErrMessage, "Accesso")
        }
        else {


          let usrC = JSON.parse(localStorage.getItem('userrentrincloud'));
          console.log("userrentrincloud ", usrC);



          this.is_pin = response['isPIN'];

          if (response['stato'] == -2) { // In Ok login ma in attesa di setta licenza                  
            this.loggatoinattesadilicenza = true;
            this.attemptingLogin = true;
            this.utenteService.SetToken(response['token']);
            // da qua ----------------------------
            this.licenze = response['licenze'];

            this.licenze.forEach(element => {
              element['disabled'] = !element['isAttiva'];
            });


            this.data = new ArrayStore({
              data: this.licenze,
              key: "id"
            });
            this.LicenzaSelezionata = "";
            this.LicenzaSelezionataDB = 0;
            this.UtenteOwner = false;
            this.UtenteOwner = response['isOwner'];

            if (!this.UtenteOwner) {
              if (this.licenze.length == 0) {
                alert("Utente non associato a nessuna Licenza", "Accesso");
                return;
              }
            }

            if (this.licenze.length > 0) {
              this.LicenzaSelezionata = this.licenze[0]['id'];
              this.tipoUserLicenzaSelect = this.licenze[0]['tipoUtente'];
              // if(this.tipoUserLicenzaSelect>2) 
              /*this.DammiAziendeDiLavoro(this.LicenzaSelezionata).then(response=>{

              });*/

            }
            if (this.UtenteOwner) this.LicenzaSelezionata = "00000"; else {
              if (this.licenze.length == 1) this.LicenzaSelezionata = this.licenze[0]['id']
            }
            this.nomeutente = response['nomeCompleto'];
            this.UtenteSmallLogin = "url('" + environment.BASE_PUBLIC_IMAGE + response['foto'] + this.tme + "')";
            // this.fotoprofilo=environment.BASE_PUBLIC_IMAGE;
            if (response['foto']) $("#form-avatar").css("background-image", this.UtenteSmallLogin);
            this.Newusername = this.username;
            //this.utenteService.AccessiExagerato.connesso=true;//user=this.username;
            localStorage.setItem('EXAGERATOWEB', JSON.stringify(this.utenteService.AccessiExagerato.user));

            //this.utenteService.AccessiExagerato.connesso=true;
            localStorage.setItem('EXAGERATOWEB', JSON.stringify(this.utenteService.AccessiExagerato.user));
            this.BtnText = "Imposta Licenza";
            localStorage.setItem('userrentrincloud', JSON.stringify(response));
            //response['owner']=this.UtenteOwner;
            //response['licenzeSelected']=this.LicenzaSelezionata;
            this.utenteService.SetetUserInfo(response);
            //alert("Loggato","login");

            if (this.UtenteOwner) {

              this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso);
              this.route.navigate(['/owner']).then(e => {



              }).catch(error => {
                console.log(error)
              })

              //this.route.navigate(['/owner'], { skipLocationChange: false });
              /*setTimeout(() => {
                this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso); 
              }, 200);*/

              return;

            }

            //alert(" "+response['tipoUtente'],"Tipo");
            //alert(" "+this.tipoUserLicenzaSelect,"XXXXNumero Licenze");               
            if (this.tipoUserLicenzaSelect == 2) { //SuperAdmin                  
              if (this.licenze.length == 1) {
                this.step = 20;
                this.Accedi();
                this.cdRef.detectChanges()
                return;
              } else {
                this.step = 20;
                this.cdRef.detectChanges()
                return;
              }
            }
            if (this.tipoUserLicenzaSelect > 2) { //Da admin in poi   

              this.DammiAziendeDiLavoro(this.LicenzaSelezionata).then(esponser => {
                console.log("Ecco le aziende di lavoro ", esponser);
                if (this.licenze.length == 1 && this.licenzeDB && this.licenzeDB.length == 1) {
                  this.step = 20;
                  this.Accedi(); //da aggiungere
                  this.cdRef.detectChanges()
                  return;
                } else {
                  this.step = 20;
                  this.cdRef.detectChanges()
                  return;
                }
              });
            }
            //this.step=20;
            //this.Accedi();
            return;

            if (response['tipoUtente'] == 2) {
              this.step = 20;
              this.Accedi();
              return;

            }
            this.DammiAziendeDiLavoro(this.LicenzaSelezionata).then(response => {
              if (this.licenze.length == 1 && this.licenzeDB && this.licenzeDB.length == 1) {
                this.step = 20;
                this.Accedi();
                return;
              } else {
                if (this.licenze.length == 1 && this.dataDB.length == 1) {
                  this.step = 20;
                  this.Accedi();
                  return;
                } else
                  this.step = 20;
                return;
              }
              //a qua
              this.step = 20;

            });


            return;
            //this.RichiediNuovoPin(this.is_pin);
            //this.RichiediNuovoPin(1);
            //this.is_pin_notifica=response['data'][0]['tiponotificapin'];
            //this.RichiediNuovoPin(this.is_pin_notifica);

            //this.step=2;
            //this.BtnText="ok";
            //this.ErrMessage="E' stato inviato PIN per accedere alla piattaforma"
            //this.error=1;         
          } else
            if (response['stato'] == -6) { // richiede forzatura per login
              let risposta = confirm(response['descrMessage'], "LOGIN");
              risposta.then(result => {
                if (result == true) {
                  this.Accedi(true)
                  this.cdRef.detectChanges()
                }
                else
                  return;
              })
            }
            else
              if (response['stato'] == -5) { // richiede PIN                                  
                this.temUserInfo = response;
                this.utenteService.SetToken(response['token']);
                this.RichiediNuovoPin(this.is_pin);
                this.step = 2;
                this.BtnText = "ok";
                this.ErrMessage = "E' stato inviato PIN per accedere alla piattaforma"
                this.error = 1;
                return;
              } else
                if (response['stato'] == -4 || response['stato'] == -3) { // force password
                  console.log("Token In Login -4 o -3 " + response['token']);
                  this.utenteService.SetToken(response['token']);
                  //this.RichiediNuovoPin(this.is_pin);
                  this.step = 9;
                  this.BtnText = "ok";
                  this.ErrMessage = ""
                  this.error = 0;
                } else {
                  this.utenteService.SetToken(response['token']); // setta nel provider il token di accesso
                  this.appService.GetUserInfo().then(response => {
                    this.utenteService.SetetUserInfo(response);
                    this.utenteService.AccessiExagerato.connesso = true;
                    //this.utenteService.AccessiExagerato.
                    this.attemptingLogin = true;
                    this.effects = false;

                    this.route.navigate(['/owner'], { skipLocationChange: false });
                    setTimeout(() => {
                      this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso);
                    }, 200);

                  }).catch((err: HttpErrorResponse) => {
                    this.appService.parseHttpErrorResponse(err);
                  }); // info                
                  //this.route.navigateByUrl("/dashboard",{skipLocationChange: true});
                }
          //this.step=1;
        }
      })
        .catch((err: HttpErrorResponse) => {
          this.spinner.hide();
          //this.appService.parseHttpErrorResponse(err); commentato in quanto il messaggio viene visualizzato da interceptor
        });


      return;


      this.appService.IsValidUser(this.username).then(response => {
        this.spinner.hide();
        console.log(response);
        if (response['codeMessage'] < 0) {
          this.username = '';
          this.BtnText = "ok";
          //this.err1=true
          this.ErrMessage = response['descrMessage'];//Utente non presente nella piattaforma. Riprovare'
          this.error = 1;
        } else {
          this.licenze = response['aziende'];
          this.data = new ArrayStore({
            data: this.licenze,
            key: "id"
          });
          if (this.fastLoginLicenza > "") this.LicenzaSelezionata = this.fastLoginLicenza; else {
            this.LicenzaSelezionata = "";
            this.UtenteOwner = false;
            this.UtenteOwner = response['owner'];
            if (this.licenze.length > 0) {
              this.LicenzaSelezionata = this.licenze[0]['id'];
            }
          }
          if (this.UtenteOwner) this.LicenzaSelezionata = "00000"; else {
            if (this.licenze.length == 1) this.LicenzaSelezionata = this.licenze[0]['id']
          }
          this.nomeutente = response['nomeCompleto'];
          this.UtenteSmallLogin = "url('" + environment.BASE_PUBLIC_IMAGE + response['foto'] + this.tme + "')";
          // this.fotoprofilo=environment.BASE_PUBLIC_IMAGE;
          if (response['foto']) $("#form-avatar").css("background-image", this.UtenteSmallLogin);
          this.Newusername = this.username;
          this.utenteService.AccessiExagerato.connesso = false;//user=this.username;
          localStorage.setItem('EXAGERATOWEB', JSON.stringify(this.utenteService.AccessiExagerato.user));
          this.step = 20;
          this.is_pin = response['isPIN'];
          this.is_pin_notifica = 0;//response['data'][0]['tiponotificapin'];
          if (this.is_pin == 1) this.is_pin_notifica = 'email'; else
            if (this.is_pin == 2) this.is_pin_notifica = 'sms'; else this.is_pin_notifica = '';
          //GeneraInviaPin($user)
          this.Newusername = this.username;
          this.utenteService.AccessiExagerato.connesso = false;//user=this.username;
          //this.is_pin_notifica='email';//response['data'][0]['tiponotificapin'];

          //this.utenteService.AccessiExagerato.connesso=true;
          //licenzaKey
          //localStorage.setItem('EXAGERATOWEB', JSON.stringify(this.utenteService.AccessiExagerato.user));
          localStorage.setItem('EXAGERATOWEB', JSON.stringify(this.utenteService.AccessiExagerato.user));

          //if(response['data'][0]['force_password']==1){
          //this.step=9;
          //}else{
          //  this.step=1;
          //}
          //console.log(localStorage.getItem('dataSource')); // getting
          this.BtnText = "Accedi";
          this.step = 20;
          return;
        }

      })
        .catch((err: HttpErrorResponse) => {
          this.spinner.hide();
          this.appService.parseHttpErrorResponse(err);
        });
    }
    if (this.step == 1) {




      this.spinner.show();
      this.appService.Login(this.username, this.password, this.LicenzaSelezionata, false).then(response => {
        console.log("login", response);
        this.spinner.hide();
        if (response['codeMessage'] == -1) {
          this.password = '';
          this.BtnText = "ok";
          this.ErrMessage = response['descrMessage'];
          this.err2 = true;
        }
        else {
          this.is_pin = response['isPIN'];
          if (response['stato'] == -5) { // richiede PIN            
            this.utenteService.SetToken(response['token']);
            this.RichiediNuovoPin(this.is_pin);
            //this.RichiediNuovoPin(1);
            //this.is_pin_notifica=response['data'][0]['tiponotificapin'];
            //this.RichiediNuovoPin(this.is_pin_notifica);

            this.step = 2;
            this.BtnText = "ok";
            this.ErrMessage = "E' stato inviato PIN per accedere alla piattaforma"
            this.error = 1;
          } else
            if (response['stato'] == -4) { // force password
              console.log("Token In Login -4" + response['token']);
              this.utenteService.SetToken(response['token']);
              //this.RichiediNuovoPin(this.is_pin);
              this.step = 9;
              this.BtnText = "ok";
              this.ErrMessage = ""
              this.error = 0;
            } else {
              this.utenteService.SetToken(response['token']); // setta nel provider il token di accesso
              this.appService.GetUserInfo().then(response => {
                this.utenteService.SetetUserInfo(response);
                this.utenteService.AccessiExagerato.connesso = true;
                this.attemptingLogin = true;
                this.effects = false;

                this.route.navigate(['/dashboard'], { skipLocationChange: true });
              }).catch((err: HttpErrorResponse) => {
                this.appService.parseHttpErrorResponse(err);
              }); // info

              //this.route.navigateByUrl("/dashboard",{skipLocationChange: true});
            }
          //this.step=1;
        }

      })
        .catch((err: HttpErrorResponse) => {
          this.spinner.hide();
          this.appService.parseHttpErrorResponse(err);
        });
    }
  }
  ngAfterViewInit() {
    this.effects = false;
    console.log("Ecc l'utente ", this.UtentiCheHannoAvutoAccesso)
    if (this.UltimoAccesso) {
      let ImgC = "url('" + environment.BASE_PUBLIC_IMAGE + this.UltimoAccesso['foto'] + this.tme + "')"
      $("#form-avatar").css("background-image", ImgC);
      this.username = this.UltimoAccesso['userName'];
    } else
      if (this.UtentiCheHannoAvutoAccesso.length > 0) {
        let iix = this.UtentiCheHannoAvutoAccesso.length - 1
        let ImgC = this.UtenteSmallLogin;    //"url('" + environment.BASE_PUBLIC_IMAGE + this.UtentiCheHannoAvutoAccesso[iix]['foto'] + this.tme + "')"      
        $("#form-avatar").css("background-image", ImgC);
        this.username = this.UtentiCheHannoAvutoAccesso[iix]['userName'];


      }
    this.cdRef.detectChanges()
  }


  Relogin() {

    this.appService.Login(this.username, this.password, this.LicenzaSelezionata, false).then(response => {
      if (response['codeMessage'] == -1) {
        this.password = '';
        this.BtnText = "ok";
        this.ErrMessage = response['descrMessage'];
        this.err2 = true;
        alert(this.ErrMessage, "Accesso")
      }
      else {
        this.is_pin = response['isPIN'];
        if (response['stato'] == -2) { // In Ok login ma in attesa di setta licenza                  
          this.loggatoinattesadilicenza = true;
          this.attemptingLogin = true;
          this.utenteService.SetToken(response['token']);
          // da qua ----------------------------
          this.licenze = response['licenze'];
          this.data = new ArrayStore({
            data: this.licenze,
            key: "id"
          });
          this.LicenzaSelezionata = "";
          this.UtenteOwner = false;
          this.UtenteOwner = response['isOwner'];
          if (this.licenze.length > 0) {

            this.LicenzaSelezionata = this.licenze[0]['id'];
          }
          if (this.UtenteOwner) this.LicenzaSelezionata = "00000"; else {
            if (this.licenze.length == 1) this.LicenzaSelezionata = this.licenze[0]['id']
          }
          this.nomeutente = response['nomeCompleto'];
          this.UtenteSmallLogin = "url('" + environment.BASE_PUBLIC_IMAGE + response['foto'] + this.tme + "')";
          // this.fotoprofilo=environment.BASE_PUBLIC_IMAGE;
          if (response['foto']) $("#form-avatar").css("background-image", this.UtenteSmallLogin);
          this.Newusername = this.username;
          //this.utenteService.AccessiExagerato.connesso=true;//user=this.username;
          localStorage.setItem('EXAGERATOWEB', JSON.stringify(this.utenteService.AccessiExagerato.user));
          //this.utenteService.AccessiExagerato.connesso=true;


          this.BtnText = "Imposta Licenza";
          this.utenteService.SetetUserInfo(response);
          if (this.UtenteOwner) {
            this.route.navigate(['/owner'], { skipLocationChange: false });
            return;

          }
          //this.RichiediNuovoPin(this.is_pin);
          //this.RichiediNuovoPin(1);
          //this.is_pin_notifica=response['data'][0]['tiponotificapin'];
          //this.RichiediNuovoPin(this.is_pin_notifica);

          //this.step=2;
          //this.BtnText="ok";
          //this.ErrMessage="E' stato inviato PIN per accedere alla piattaforma"
          //this.error=1;         
        } else

          if (response['stato'] == -5) { // richiede PIN            
            this.utenteService.SetToken(response['token']);
            this.RichiediNuovoPin(this.is_pin);
            //this.RichiediNuovoPin(1);
            //this.is_pin_notifica=response['data'][0]['tiponotificapin'];
            //this.RichiediNuovoPin(this.is_pin_notifica);

            this.step = 2;
            this.BtnText = "ok";
            this.ErrMessage = "E' stato inviato PIN per accedere alla piattaforma"
            this.error = 1;
          } else
            if (response['stato'] == -4) { // force password
              console.log("Token In Login -4" + response['token']);
              this.utenteService.SetToken(response['token']);
              //this.RichiediNuovoPin(this.is_pin);
              this.step = 9;
              this.BtnText = "ok";
              this.ErrMessage = ""
              this.error = 0;
            } else {
              this.utenteService.SetToken(response['token']); // setta nel provider il token di accesso
              this.appService.GetUserInfo().then(response => {
                this.utenteService.SetetUserInfo(response);
                this.utenteService.AccessiExagerato.connesso = true;
                //this.utenteService.AccessiExagerato.
                this.attemptingLogin = true;
                this.effects = false;

                this.route.navigate(['/owner'], { skipLocationChange: false });
              }).catch((err: HttpErrorResponse) => {
                this.appService.parseHttpErrorResponse(err);
              }); // info                
              //this.route.navigateByUrl("/dashboard",{skipLocationChange: true});
            }
        //this.step=1;
      }
    })
      .catch((err: HttpErrorResponse) => {
        //this.spinner.hide();
        this.appService.parseHttpErrorResponse(err);
      });

  }
  ngOnInit() {

    this.activatedroute.queryParams
      .subscribe(params => {
        if (params.idAzienda) {
          this.loginShow = false
          this.spinner.show();

          setTimeout(() => {
            this.step = 20;
            this.LicenzaSelezionata = params.idLicenza;//'C001A05';
            this.LicenzaSelezionataDB = params.idAzienda
            this.spinner.hide()
            this.Accedi();
          }, 300);


        }





      });


    this.appService.isExistsUsers().then(response => {
      this.step = (response == false) ? -1 : 0;
      if (this.step == -1) this.BtnText = "Crea Owner"
    }).catch((err: HttpErrorResponse) => {
      this.appService.parseHttpErrorResponse(err);
    }); // info



    //isExistsUsers
    //this.step=-1;
    //this.BtnText="Crea Owner"

    //} 

    registerLocaleData(localeIt, 'it-IT');

    //this.imagSource="../../../assets/images/sfondo1"+".jpg"

    if (!this.effects) {
      this.startImgIndex = Math.floor((Math.random() * 3) + 1);
      let pp = "url('../../../assets/images/carosello_login/sfondo" + this.startImgIndex + ".jpg')";
      $('#sect1').css({ 'background-image': pp })
    } else {
      let pp = "url('../../../assets/images/carosello_login/sfondo" + this.startImgIndex + ".jpg')";
      $('#sect1')
        .animate({ opacity: 0 }, 'slow', function () {
          $(this)
            .css({ 'background-image': pp })
            .animate({ opacity: 1 });
        });

    }


    //  this.todaysDataTime = formatDate(this.now, 'dd-MM-yyyy hh:mm:ss ','it-IT');
    //this.pippo='assets/images/color-scheme-carmine.svg';
    this.cdRef.detectChanges()
  }

  setNewLoginByAzienda(params) {
    console.log(params)
  }
  passwordComparison = () => this.newpass;
  passwordComparisonOwner = () => this.passOwner;
}
export class Product {
  ID: number;
  Name: string;
  Price: number;
  Current_Inventory: number;
  Backorder: number;
  Manufacturing: number;
  Category: string;
  ImageSrc: string;
}
export class Licenze {
  id: string;
  descrizione: string;
}
export class LicenzeDB {
  id: number;
  idLicenza: string;
  descrizione: string;
}
